<div id="supplier-interactive-schedule">
  <div class="full-height">
    <div class="main-flex">
      <div class="flex-inner">
        <div class="pt-3 pb-1">
          <div style="display: flex">
            <div class="text-center" style="flex-grow: 1">
              <h2 class="m-0 p-0">Your Tasks</h2>
            </div>
            <div style="flex-shrink: 1" class="filter-icon">
              <div class="pr-2 pb-2" style="font-size: 20px">
                <span class="mobile-menu" (click)="toggleFilters()"
                  ><i class="fa fa-filter"></i
                ></span>
              </div>
            </div>
          </div>
        </div>

        <div style="flex-grow: 1; overflow-y: auto" class="filters" [class.show]="showFilters">
          <div *ngIf="showSearch; else showResult" style="height: 100%">
            <div class="facets-flex-wrapper" *ngIf="filterGroups.length > 0; else loadingFilters">
              <div id="facets-list-container" class="facets-container">
                <div class="facets-inner-container">
                  <div
                    id="facetslist"
                    class="facets-list"
                    *ngFor="let filter of filterGroups; let i = index"
                  >
                    <p-panel
                      id="engineius-panel-{{ i }}"
                      [pTooltip]="filterDefinitions[i].tooltip"
                      tooltipPosition="top"
                    >
                      <p-header>
                        <div class="facet-title-bar">
                          <div class="facet-title-text" (click)="isFacetOpen[i] = !isFacetOpen[i]">
                            <span *ngIf="!isFacetOpen[i]"><i class="fa fa-caret-down"></i></span>
                            <span *ngIf="isFacetOpen[i]"><i class="fa fa-caret-up"></i></span>
                            {{ filter.name }}
                            <span
                              *ngIf="selectedFilters[i] && selectedFilters[i].length > 0"
                              [escape]="false"
                              [tooltipStyleClass]="'xtooltip'"
                              [pTooltip]="getSelectedFiltersString(i)"
                              class="p-badge filters"
                              style="text-align: center; cursor: pointer"
                              >{{ selectedFilters[i].length }}</span
                            >
                          </div>

                          <div style="flex-grow: 1">
                            <input
                              *ngIf="filterDefinitions[i].searchable"
                              [(ngModel)]="filterDefinitions[i].searchKeyword"
                              autocomplete="off"
                              name="filter"
                              class="filter-input"
                              (input)="applyFilter(i, $event.target.value, 'label', 'contains')"
                            />

                            <input
                              (change)="applyInput(i, $event.target.value)"
                              *ngIf="filterDefinitions[i].input"
                              autocomplete="chrome-off"
                              [placeholder]="filterDefinitions[i].placeholder"
                              [(ngModel)]="filterDefinitions[i].searchKeyword"
                              [class]="'filter-input filter-' + filterDefinitions[i].propertyName"
                              name="filter"
                            />
                          </div>

                          <div
                            style="flex-shrink: 1"
                            *ngIf="filterDefinitions[i].searchable"
                            pTooltip="Filter the list by name"
                            class="filter-search-icon"
                          >
                            <i class="fa fa-search"></i>
                          </div>

                          <div *ngIf="isFacetLoading[i]">
                            <i class="fa fa-spin fa-spinner"></i>
                          </div>

                          <div
                            style="flex-shrink: 1; white-space: nowrap"
                            *ngIf="isFacetOpen[i] == true"
                          >
                            <div
                              pTooltip="Switch between alphabetic and 'highest count' ordering"
                              class="filter-sort-icon"
                              (click)="sortFilter(i)"
                            >
                              <i class="fa fa-sort"></i>
                            </div>
                          </div>
                        </div>
                      </p-header>
                      <p-table
                        selectionMode="multiple"
                        [(selection)]="selectedFilters[i]"
                        [value]="filter.selectItems"
                        [lazy]="false"
                        (onRowSelect)="filterRowSelectionChanged(i)"
                        (onRowUnselect)="filterRowSelectionChanged(i)"
                        *ngIf="!isFacetLoading[i]"
                        id="facetTable"
                        #facetTable
                        [paginator]="false"
                        rowHover="true"
                        resizableColumns="true"
                        [metaKeySelection]="false"
                        [style]="{
                          'max-height': '200px',
                          'overflow-y': 'scroll',
                          display: isFacetOpen[i] ? 'block' : 'none'
                        }"
                        (onFilter)="handleFilter($event, facetTable.totalRecords)"
                      >
                        <ng-template pTemplate="body" let-data>
                          <tr [pSelectableRow]="data">
                            <td>
                              <span
                                [ngClass]="{ 'red-label': data.dataOutOfRange }"
                                appendTo="body"
                                pTooltip="{{ data.label }}"
                                tooltipPosition="top"
                                >{{ data.label }}</span
                              >
                            </td>
                            <td style="width: 50px">
                              <span class="p-badge">{{ data.count }}</span>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-panel>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #loadingFilters>
              <div style="height: 100%">
                <div style="display: flex; align-items: center; height: 100%; text-align: center">
                  <div style="width: 100%">
                    <div><i class="fa fa-spin fa-spinner fa-2x"></i></div>
                    <div class="pt-2"><strong>Filters Loading</strong></div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>

          <ng-template #showResult>
            <div
              style="height: 100%; display: flex; flex-direction: column"
              *ngIf="!isLoading; else showIsLoading"
            >
              <div style="flex-shrink: 1" class="p-1 text-center">
                <div style="line-height: 25px; font-size: 15px; font-weight: bold">
                  {{ workingSet.length }} Tasks across {{ getWorkingSetCountAsTotalJobs() }} Jobs
                </div>
              </div>

              <div style="padding: 7px 2px 5px 1px">
                <div *ngIf="showSearch; else showFiltersButton"></div>
                <ng-template #showFiltersButton>
                  <div class="text-center pb-2">
                    <div class="d-flex flex-wrap gap-1">
                      <div class="flex-grow-1">
                        <button
                          pButton
                          label="Filters"
                          [icon]="'fa fa-filter'"
                          (click)="hideResults()"
                          [class.button-highlight]="filterCount > 0"
                          style="width: 100%"
                          id="viewfilters-button"
                        ></button>
                      </div>
                      <div class="flex-grow-1">
                        <button
                          pButton
                          label="Watched"
                          [icon]="'fa fa-eye'"
                          [class.button-highlight]="filterWatched"
                          (click)="filterWatched = !filterWatched"
                          style="width: 95%"
                          id="watched-button"
                        ></button>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <div class="d-flex sortby">
                  <div
                    (click)="changeSortBy(1)"
                    [class.selected]="sortby == 1"
                    class="flex-grow-1 text-center sortby-item cursor-pointer"
                  >
                    Distance
                    <span *ngIf="sortby == 1"
                      ><i [class]="sortByAscending ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i
                    ></span>
                  </div>
                  <div
                    (click)="changeSortBy(2)"
                    [class.selected]="sortby == 2"
                    class="flex-grow-1 text-center sortby-item cursor-pointer"
                  >
                    <span *ngIf="sortByAscending">Starting Soon</span>
                    <span *ngIf="!sortByAscending">Starting Later</span>
                  </div>
                  <div
                    (click)="changeSortBy(4)"
                    [class.selected]="sortby == 4"
                    class="flex-grow-1 text-center sortby-item cursor-pointer"
                  >
                    <span *ngIf="sortByAscending">Newest First</span>
                    <span *ngIf="!sortByAscending">Oldest First</span>
                  </div>
                  <div
                    (click)="changeSortBy(3)"
                    [class.selected]="sortby == 3"
                    class="flex-grow-1 text-center sortby-item cursor-pointer"
                  >
                    Price
                    <span *ngIf="sortby == 3"
                      ><i [class]="sortByAscending ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div
                style="flex-grow: 1; overflow-y: auto; padding-top: 10px"
                id="resultslist-wrapper"
              >
                <div
                  class="resultslist"
                  id="resultslist"
                  *ngFor="let item of filterResultSet(resultSet); let i = index"
                >
                  <div id="intro-task-{{ i }}">
                    <ng-container
                      *ngTemplateOutlet="jobItem; context: { result: item, i: i }"
                    ></ng-container>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #showIsLoading>
              <div
                style="
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  font-weight: bold;
                  font-size: 18px;
                "
              >
                <div class="text-center">
                  <div><i class="fa fa-spin fa-spinner"></i></div>
                  <div class="mt-2">Loading Tasks</div>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </div>

        <div
          style="
            flex: 0 0 55px;
            width: 100%;
            padding-top: 11px;
            padding-bottom: 11px;
            background-color: #ddd;
            padding-left: 5px;
            padding-right: 10px;
            box-sizing: border-box;
            text-align: center;
          "
          class="filters"
          [class.show]="showFilters"
          *ngIf="showSearch"
        >
          <div style="display: flex; flex-wrap: wrap; width: 100%">
            <div
              style="flex-grow: 1; padding-left: 5px; padding-right: 5px; box-sizing: border-box"
            >
              <button
                pButton
                label="Show {{ workingSet.length }} tasks"
                (click)="showSearch = !showSearch"
                style="width: 100%"
              ></button>
            </div>
            <div
              style="flex-shrink: 1; padding-left: 5px; padding-right: 5px; box-sizing: border-box"
            >
              <button
                pButton
                [label]="'Clear'"
                (click)="clearAllFilters()"
                style="width: 100%"
              ></button>
            </div>
          </div>
        </div>
      </div>
      <div style="flex-grow: 1; overflow-y: auto" class="filters" [class.show]="!showFilters">
        <div style="width: 100%; height: 100%">
          <interactive-schedule
            [supplierIds]="supplierIds"
            [inputJobs]="selectedJobs"
            (inputJobsChangeEvent)="inputJobsUpdate($event)"
            (pendingChangesUpdate)="changesUpdate($event)"
            [isVME]="false"
          >
          </interactive-schedule>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #jobItem let-result="result" let-i="i">
  <div class="px-2">
    <div
      class="results-grid results-list"
      [ngClass]="isJobSelected(result.jobId) ? 'selected' : 'not-selected'"
      (dblclick)="viewJob(result.jobId)"
      (click)="selectedJobChanged(result)"
    >
      <div class="head-bar">
        <div class="d-flex">
          <div class="flex-shrink-1">
            <div
              class="buy-now-price"
              *ngIf="!linkedToPrevious(result) && result.buyItNowPrice > 0"
            >
              {{ result.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
            </div>
          </div>
          <div class="flex-grow-1">
            <div class="watch-info" *ngIf="!linkedToPrevious(result)">
              <i
                (click)="toggleWatched($event, result)"
                class="fa fa-eye watch-icon"
                [pTooltip]="
                  result.supplierWatched == 'Yes'
                    ? 'Watched. Click to not watch'
                    : 'Not watched. Click to watch'
                "
                [class.fa-ellipsis-h]="updatePending == result.jobId"
                [class.fa-eye-slash]="
                  result.supplierWatched == 'Yes' && updatePending != result.jobId
                "
                [class.fa-eye]="result.supplierWatched != 'Yes' && updatePending != result.jobId"
              ></i>
            </div>
          </div>
          <div class="flex-shrink-1">
            <div class="trip-info">{{ result.moveDistance }} Miles</div>
          </div>
        </div>
      </div>

      <table style="width: 100%">
        <tr>
          <td class="shrink-cell pick-up-color text-center">
            <span class="pick-up-color">
              <i class="vme-material-icons">&#xe805;</i>
            </span>
          </td>
          <td>
            <div class="date-value">
              {{ result.earliestPickupDate | date : 'EEE dd MMM HH:mm' }}
              - {{ result.latestPickupDate | date : 'EEE dd MMM HH:mm' }}
            </div>
            <div class="location">
              {{ result.from }}
            </div>
          </td>
        </tr>

        <tr>
          <td class="shrink-cell drop-off-color text-center">
            <div>
              <i class="vme-material-icons">&#xe804;</i>
            </div>
          </td>
          <td>
            <div class="date-value">
              {{ result.earliestDropOffDate | date : 'EEE dd MMM HH:mm' }}
              - {{ result.latestDropOffDate | date : 'EEE dd MMM HH:mm' }}
            </div>
            <div class="location">
              {{ result.to }}
            </div>
          </td>
        </tr>
      </table>
      <div class="vrm-line">
        <div class="vrm">{{ result.vehicleReg }}</div>
        <div class="vehicle-info">{{ result.vehicleRegDetails }}</div>

        <div (click)="showMap($event, i, result)" [id]="'jobmap-' + i" class="job-map">
          <span *ngIf="showingMap[i]">Close map</span>
          <span *ngIf="!showingMap[i]">Show map</span>
        </div>
      </div>
    </div>
    <div *ngIf="linkedJob(result)" class="linked-job"><i class="fa fa-arrows-v"></i> same job</div>
    <div *ngIf="!linkedJob(result)" class="not-linked-job"></div>

    <div class="pb-3" [id]="'mapcontainer-' + i" style="margin-top: -20px" *ngIf="showingMap[i]">
      <div class="pr-1">
        <div class="tooltip" style="width: 100%; height: 150px">
          <div *ngIf="loadingMap[i]">
            <div class="spinner"><i class="fa fa-spin fa-spinner"></i> Loading map</div>
          </div>
          <div *ngIf="!loadingMap[i] && mapCode[i]">
            <img [src]="mapCode[i]" alt="Map" style="width: 100%" />
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<p-confirmDialog
  header="Confirmation"
  icon="fa fa-question-circle"
  [style]="{ width: '425px' }"
></p-confirmDialog>
